"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const Field_1 = __importDefault(require("../_classes/field/Field"));
const Input_1 = __importDefault(require("../_classes/input/Input"));
const AriFormUtils = __importStar(require("../../utils/utils"));
const utils_1 = require("../../utils/utils");
const sweetalert_1 = __importDefault(require("sweetalert"));
const AriForm_1 = require("../../AriForm");
class ButtonComponent extends Field_1.default {
    static schema(...extend) {
        return Input_1.default.schema({
            type: 'button',
            label: 'Submit',
            key: 'submit',
            size: 'md',
            leftIcon: '',
            rightIcon: '',
            block: false,
            action: 'aripost', //Fiona
            persistent: false,
            disableOnInvalid: false,
            theme: 'primary',
            btnType: 'contained',
            dataGridLabel: true,
            isLoading: false,
        }, ...extend);
    }
    static get builderInfo() {
        return {
            title: 'Button',
            group: 'basic',
            icon: 'stop',
            documentation: '/userguide/form-building/form-components#button',
            weight: 110,
            schema: ButtonComponent.schema()
        };
    }
    static savedValueTypes(schema) {
        return (0, utils_1.getComponentSavedTypes)(schema) || [utils_1.componentValueTypes.boolean];
    }
    constructor(component, options, data) {
        super(component, options, data);
        this.filesUploading = [];
        this.otpInfo = {};
        this.countdownTime = 0;
        this.countdownEl = null;
        this.interval = null;
        this.resendEvent = null;
        this.bsModal = null;
        this.listeners = {};
        this.hanldeclickCloseOTP = null;
        this.handleClickSubmit = null;
        this.otpInputs = ['otp1', 'otp2', 'otp3', 'otp4', 'otp5', 'otp6'];
        this.authenKey = null;
        this.authenType = null;
        this.mdChooseOptions = null;
        this.submitModelChooseOptions = null;
        this.closeModelChooseOptions = null;
        this.isClosingModal = null;
        this.cleanupModalEvents = null;
        this.handleModalHidden = null;
    }
    get defaultSchema() {
        return ButtonComponent.schema();
    }
    get inputInfo() {
        const info = super.elementInfo();
        info.type = 'button';
        info.attr.type = (['submit', 'saveState'].includes(this.component.action)) ? 'submit' : 'button';
        this.component.theme = this.component.theme || 'default';
        this.component.btnType = this.component.btnType || 'contained';
        info.attr.class = `btn btn-${this.component.theme} btn-${this.component.btnType}`;
        if (this.component.tooltipPosition) {
            info.attr['data-placement'] = this.component.tooltipPosition;
        }
        if (this.component.toolltipHover) {
            info.attr['title'] = this.component.toolltipHover;
        }
        if (this.component.showtooltipHover) {
            info.attr['data-toggle'] = "tooltip";
        }
        if (this.component.size) {
            info.attr.class += ` btn-${this.component.size}`;
        }
        const customClass = info.component.customClass || '';
        if (this.component.backHeader && !customClass.includes('btn-back-header')) {
            info.component.customClass = `${customClass} btn-back-header`.trim();
        }
        if (this.component.block) {
            info.attr.class += ' btn-block';
        }
        if (this.component.customClass) {
            info.attr.class += ` ${this.component.customClass}`;
        }
        info.content = this.t(this.component.label, { _userInput: true });
        return info;
    }
    get labelInfo() {
        return {
            hidden: true
        };
    }
    set loading(loading) {
        this.setLoading(this.refs.button, loading);
    }
    get skipInEmail() {
        return true;
    }
    // No label needed for buttons.
    createLabel() { }
    createInput(container) {
        this.refs.button = super.createInput(container);
        return this.refs.button;
    }
    get emptyValue() {
        return false;
    }
    getValue() {
        return this.dataValue;
    }
    get clicked() {
        return this.dataValue;
    }
    get defaultValue() {
        return false;
    }
    get className() {
        let className = super.className;
        className += ` ${this.transform('class', 'form-group')}`;
        return className;
    }
    get oauthConfig() {
        if (lodash_1.default.has(this, 'root.form.config.oauth') && this.component.oauthProvider) {
            return this.root.form.config.oauth[this.component.oauthProvider];
        }
        // Legacy oauth location.
        if (this.component.oauth) {
            return this.component.oauth;
        }
        return false;
    }
    render() {
        if (this.viewOnly || this.options.hideButtons) {
            this._visible = false;
        }
        return super.render(this.renderTemplate('button', {
            component: this.component,
            input: this.inputInfo,
        }));
    }
    attachButton() {
        this.addShortcut(this.refs.button);
        let onChange = null;
        let onError = null;
        if (this.component.action === 'submit') {
            this.on('submitButton', () => {
                this.disabled = true;
            }, true);
            this.on('cancelSubmit', () => {
                this.disabled = false;
            }, true);
            this.on('submitDone', (message) => {
                const resultMessage = lodash_1.default.isString(message) ? message : this.t('complete');
                this.loading = false;
                this.disabled = false;
                this.addClass(this.refs.button, 'btn-success submit-success');
                this.removeClass(this.refs.button, 'btn-danger submit-fail');
                this.addClass(this.refs.buttonMessageContainer, 'has-success');
                this.removeClass(this.refs.buttonMessageContainer, 'has-error');
                this.setContent(this.refs.buttonMessage, resultMessage);
            }, true);
            this.on('submitError', (message) => {
                const resultMessage = lodash_1.default.isString(message) ? this.t(message) : this.t(this.errorMessage('submitError'));
                this.loading = false;
                this.disabled = false;
                this.hasError = true;
                this.removeClass(this.refs.button, 'btn-success submit-success');
                this.addClass(this.refs.button, 'btn-danger submit-fail');
                this.removeClass(this.refs.buttonMessageContainer, 'has-success');
                this.addClass(this.refs.buttonMessageContainer, 'has-error');
                this.setContent(this.refs.buttonMessage, resultMessage);
            }, true);
            this.on('fileUploadingStart', (filePromise) => {
                this.filesUploading.push(filePromise);
                this.disabled = true;
                this.setDisabled(this.refs.button, this.disabled);
            }, true);
            this.on('fileUploadingEnd', (filePromise) => {
                const index = this.filesUploading.indexOf(filePromise);
                if (index !== -1) {
                    this.filesUploading.splice(index, 1);
                }
                this.disabled = this.shouldDisabled ? true : false;
                this.setDisabled(this.refs.button, this.disabled);
            }, true);
            onChange = (value, isValid) => {
                this.removeClass(this.refs.button, 'btn-success submit-success');
                if (isValid) {
                    this.removeClass(this.refs.button, 'btn-danger submit-fail');
                    if (this.hasError) {
                        this.hasError = false;
                        this.setContent(this.refs.buttonMessage, '');
                        this.removeClass(this.refs.buttonMessageContainer, 'has-success');
                        this.removeClass(this.refs.buttonMessageContainer, 'has-error');
                    }
                }
            };
            onError = () => {
                this.hasError = true;
                this.removeClass(this.refs.button, 'btn-success submit-success');
                this.addClass(this.refs.button, 'btn-danger submit-fail');
                this.removeClass(this.refs.buttonMessageContainer, 'has-success');
                this.addClass(this.refs.buttonMessageContainer, 'has-error');
                this.setContent(this.refs.buttonMessage, this.t(this.errorMessage('submitError')));
            };
        }
        if (this.component.action === 'url') {
            this.on('requestButton', () => {
                this.disabled = true;
            }, true);
            this.on('requestDone', () => {
                this.loading = false;
                this.disabled = false;
            }, true);
        }
        this.on('change', (value, flags) => {
            let isValid = value.isValid;
            const isSilent = flags && flags.silent;
            //check root validity only if disableOnInvalid is set and when it is not possible to make submission because of validation errors
            if (flags && flags.noValidate && (this.component.disableOnInvalid || this.hasError)) {
                isValid = flags.rootValidity || (this.root ? (this.root.validate(this.root.data, { dirty: false, silentCheck: true }).length === 0) : true);
                flags.rootValidity = isValid;
            }
            this.isDisabledOnInvalid = this.component.disableOnInvalid && (isSilent || !isValid);
            this.disabled = this.shouldDisabled;
            this.setDisabled(this.refs.button, this.disabled);
            if (onChange) {
                onChange(value, isValid);
            }
        }, true);
        this.on('error', () => {
            this.loading = false;
            this.disabled = false;
            if (onError) {
                onError();
            }
        }, true);
        //Simple 20230324 disable button and show loading
        this.on('postAriStart', (args) => {
            if (args && args === this.component.id) {
                this.loading = true;
                this.disabled = true;
            }
        }, true);
        this.on('postAriDone', (args) => {
            if (args && args === this.component.id) {
                this.loading = false;
                this.disabled = false;
            }
        }, true);
        //end simple
        if (this.component.saveOnEnter) {
            this.root.addEventListener(this.root.element, 'keyup', (event) => {
                if (event.keyCode === 13) {
                    this.onClick.call(this, event);
                }
            });
        }
        this.addEventListener(this.refs.button, 'click', this.onClick.bind(this));
        this.addEventListener(this.refs.buttonMessageContainer, 'click', () => {
            if (this.refs.buttonMessageContainer.classList.contains('has-error')) {
                if (this.root && this.root.alert) {
                    this.scrollIntoView(this.root.alert);
                }
            }
        });
        this.disabled = this.shouldDisabled;
        this.setDisabled(this.refs.button, this.disabled);
        /**
         * Get url parameter by name
         * @param {string} name - The url parameter
         * @returns {string} - The url parameter value
         */
        function getUrlParameter(name) {
            name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
            const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
            const results = regex.exec(location.search);
            if (!results) {
                return results;
            }
            return decodeURIComponent(results[1].replace(/\+/g, ' '));
        }
        // If this is an OpenID Provider initiated login, perform the click event immediately
        if ((this.component.action === 'oauth') && this.oauthConfig && !this.oauthConfig.error) {
            const iss = getUrlParameter('iss');
            if (iss && (this.oauthConfig.authURI.indexOf(iss) === 0)) {
                this.openOauth(this.oauthConfig);
            }
        }
    }
    get shouldDisabled() {
        var _a;
        return super.shouldDisabled || !!((_a = this.filesUploading) === null || _a === void 0 ? void 0 : _a.length) || this.isDisabledOnInvalid;
    }
    attach(element) {
        this.loadRefs(element, {
            button: 'single',
            buttonMessageContainer: 'single',
            buttonMessage: 'single',
        });
        const superAttach = super.attach(element);
        this.attachButton();
        return superAttach;
    }
    /* eslint-enable max-statements */
    detach(element) {
        if (element && this.refs.button) {
            this.removeShortcut(this.refs.button);
        }
        super.detach();
    }
    //Fiona
    buildBodyBpmSubmit(form) {
        let datamapping = form.formState.mappingData; //|| JSON.parse(getVariable("mappingData"));
        let dataset = {};
        var ariFilePaths = [];
        var ariFileIds = [];
        datamapping.map((v) => {
            var _a, _b;
            var comp = form.getComponent(v.formField);
            if (!v.formField || (v === null || v === void 0 ? void 0 : v.isSubmit) === false) {
                return;
            }
            if (comp && comp.getValue()) {
                const comValue = comp.getValue();
                switch (comp.type) {
                    case 'show': break;
                    // case 'signature':
                    //   ariFilePaths.push(`dataset.${v.datasetField}`);
                    //   dataset[v.datasetField] = {
                    //     url: comp.getValue(),
                    //     type: 'image/png',
                    //     originalName: 'signature.png'
                    //   };
                    //   break;
                    case 'file':
                        if (((_a = comp.component) === null || _a === void 0 ? void 0 : _a.storage) === 'base64') {
                            ariFilePaths.push(`dataset.${v.datasetField}${comValue.length > 1 ? '[:]' : ''}`);
                            dataset[v.datasetField] = comValue.length > 1 ? comValue : comValue[0];
                        }
                        else if (((_b = comp.component) === null || _b === void 0 ? void 0 : _b.storage) === 'internalmedia') {
                            dataset[v.datasetField] = comValue.length > 1 ? comValue === null || comValue === void 0 ? void 0 : comValue.map(v => v.filePath) : comValue.length > 0 ? comValue[0].filePath : '';
                        }
                        else {
                            dataset[v.datasetField] = comValue;
                        }
                        if (Array.isArray(dataset[v.datasetField])) {
                            ariFileIds.push(...dataset[v.datasetField]);
                        }
                        else {
                            ariFileIds.push(dataset[v.datasetField]);
                        }
                        break;
                    default:
                        dataset[v.datasetField] = comValue;
                        break;
                }
            }
        });
        AriForm_1.AriForm.inputComponents.push("button");
        const targetTypes = AriFormUtils.getKeysByType(form.components, AriForm_1.AriForm.inputComponents);
        targetTypes.forEach((component) => {
            var _a, _b;
            try {
                if (((_a = component.component) === null || _a === void 0 ? void 0 : _a.action) === 'back' || component.component.notDisableWhenSubmitBPM) {
                    //dont do anything
                }
                else {
                    if (component.type === 'select') {
                        component.component._originalClearOnRefresh = component.component.clearOnRefresh;
                        component.component._originalRefreshOn = component.component.refreshOn;
                        component.component.clearOnRefresh = false;
                        component.component.refreshOn = "";
                    }
                    component.disabled = true;
                    component.persistent = true;
                    if (component === null || component === void 0 ? void 0 : component.component) {
                        component.component.persistent = true;
                        component.component.disabled = true;
                    }
                }
                (_b = component.redraw) === null || _b === void 0 ? void 0 : _b.call(component);
            }
            catch (error) {
                console.error(`Error disabling component ${component.key}:`, error);
            }
        });
        return { dataset, ariFilePaths, ariFileIds };
    }
    enableComponents(form) {
        const targetTypes = AriFormUtils.getKeysByType(form.components, AriForm_1.AriForm.inputComponents);
        targetTypes.forEach((component) => {
            var _a, _b;
            try {
                if (((_a = component.component) === null || _a === void 0 ? void 0 : _a.action) === 'back' || component.component.notDisableWhenSubmitBPM) {
                    //dont do anything
                }
                else {
                    if (component.type === 'select') {
                        if (component.component._originalClearOnRefresh !== undefined) {
                            component.component.clearOnRefresh = component.component._originalClearOnRefresh;
                            delete component.component._originalClearOnRefresh;
                        }
                        if (component.component._originalRefreshOn !== undefined) {
                            component.component.refreshOn = component.component._originalRefreshOn;
                            delete component.component._originalRefreshOn;
                        }
                    }
                    component.disabled = false;
                    component.persistent = false;
                    if (component === null || component === void 0 ? void 0 : component.component) {
                        component.component.persistent = false;
                        component.component.disabled = false;
                    }
                }
                (_b = component.redraw) === null || _b === void 0 ? void 0 : _b.call(component);
            }
            catch (error) {
                console.error(`Error disabling component ${component.key}:`, error);
            }
        });
    }
    callAPIDoTask(endpoint, request, body, form, ariHeader, ariLang, dataResult) {
        if (this.component.needOtp) {
            const authenCode = this.authenType === "BIOMETRIC" ? dataResult.data.id : this.getFullOtpValue();
            body.authentication = {
                "authenType": this.authenType,
                "authenCode": authenCode,
                "authenKey": this.authenType === "BIOMETRIC" ? form.formState.custInfo.cif : this.otpInfo.authenKey || '',
            };
        }
        const handleSuccessBpmCommit = (result) => {
            form.formState.dotaskComPlete = true;
            const flattened = AriFormUtils.flattenComponents(form.component.components, true);
            // Create object containing the corresponding HTML element components
            const components = {};
            lodash_1.default.each(flattened, (component, key) => {
                const element = form.getComponent(key);
                if (element) {
                    components[key] = element;
                }
            });
            // const buildBodyBpmSubmit = {
            //   "params": {
            //     "taskId": result.taskId,
            //   },
            //   // "tokenInfo": {
            //   //   "channelId": "MB",
            //   //   "ctmLicenseNo": null,
            //   //   "ctmCif": "11000900"
            //   // }
            // }
            // if (AriForm.serviceId === 'ctm') {
            //   AriFormUtils.removeLoadingFullScreen();
            //   this.callAPINextStep(buildBodyBpmSubmit, ariHeader, ariLang, this.component.ariOnSucess, form, components, flattened);
            // } else {
            AriFormUtils.removeLoadingFullScreen();
            this.evaluate(this.component.ariOnSucess, {
                form,
                flattened,
                components,
                result
            });
            // }
            if (this.bsModal) {
                this.bsModal.hide();
                this.clearInputOTP();
            }
            if (form.clearDraft) {
                form.clearDraft();
            }
        };
        const handleErrorBpmCommit = (error) => {
            var _a, _b;
            AriFormUtils.removeLoadingFullScreen();
            let parsedDetail = null;
            if ((_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a.responseDesc) {
                const detail = (_b = error === null || error === void 0 ? void 0 : error.error) === null || _b === void 0 ? void 0 : _b.responseDesc;
                parsedDetail =
                    typeof detail === 'string'
                        ? (() => {
                            try {
                                return JSON.parse(detail).responseDesc;
                            }
                            catch (_a) {
                                return detail;
                            }
                        })()
                        : detail;
            }
            AriFormUtils.showPopup('error', 'Failed', parsedDetail);
            form.formState.mappingData.push("button");
            this.enableComponents(form);
            if (document.querySelector('.bpm-do-task-pdf')) {
                document.querySelector('.bpm-do-task-pdf').removeAttribute("disabled");
            }
        };
        AriFormUtils.handleCAllAPI(`${AriForm_1.AriForm.baseUrl}/${AriForm_1.AriForm.serviceId}/${endpoint}`, 'POST', body, {}, handleSuccessBpmCommit, handleErrorBpmCommit);
    }
    callApiCheckInfo(endpoint, request, body, form, ariHeader, ariLang) {
        const handleSuccessCheckInfo = (result) => {
            var _a, _b, _c;
            AriFormUtils.removeLoadingFullScreen();
            this.otpInfo = result;
            if (this.countdownTime > 0) {
                this.bsModal.show();
            }
            else {
                //Xoá modal cũ nếu đang mở
                if (!this.resendEvent) {
                    if (this.bsModal) {
                        this.bsModal.hide();
                        this.bsModal = null;
                    }
                    //Xoá wrapper cũ nếu có
                    const oldWrapper = document.querySelector('.otp-wrapper');
                    if (oldWrapper) {
                        oldWrapper.remove();
                    }
                    // Tạo lại wrapper mới
                    const otpWrapper = document.createElement('div');
                    otpWrapper.className = 'otp-wrapper';
                    document.body.appendChild(otpWrapper);
                }
                this.resendEvent = false;
                let modalEl = document.getElementById('otp-modal');
                if (!modalEl) {
                    document.querySelector('.otp-wrapper').innerHTML = this.renderOtpCode();
                    modalEl = document.getElementById('otp-modal');
                    this.bsModal = new window.bootstrap.Modal(modalEl);
                    this.bsModal.show();
                }
                else {
                    const countdownText = document.querySelector('.coundown-wraper .countdown-text');
                    if (countdownText)
                        countdownText.textContent = ''; // reset về trống trước
                    this.countdownEl.classList.remove('hidden');
                    document.querySelector('.wraper-resend-otp-btn').classList.add('d-none');
                    // 2. Reset lại các input
                    this.otpInputs.forEach(id => {
                        const input = document.getElementById(id);
                        if (input)
                            input.value = '';
                    });
                }
                const otpWrapper = document.querySelector('.otp-wrapper');
                this.countdownEl = otpWrapper.querySelector('.coundown-wraper');
                this.countdownTime = result.otpExpiredTime * 60 || 0;
                this.startCountdown();
                this.hanldeclickCloseOTP = () => {
                    if (this.bsModal) {
                        this.bsModal.hide();
                        this.clearInputOTP();
                        this.enableComponents(form);
                        this.checkOtpComplete();
                    }
                };
                this.handleClickSubmit = () => {
                    AriFormUtils.loadingFullScreen();
                    document.querySelector('.bpm-do-task-pdf').setAttribute('disabled', true);
                    this.callAPIDoTask(endpoint, request, body, form, ariHeader, ariLang);
                };
                if (this.hanldeclickCloseOTP) {
                    (_a = document.querySelector('.close-modal-otp')) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', this.hanldeclickCloseOTP);
                }
                (_b = document.querySelector('.close-modal-otp')) === null || _b === void 0 ? void 0 : _b.addEventListener('click', this.hanldeclickCloseOTP);
                (_c = document.querySelector('.bpm-do-task-pdf')) === null || _c === void 0 ? void 0 : _c.addEventListener('click', this.handleClickSubmit);
                this.initOtpInputs();
                const resendBtn = document.querySelector('.resend-otp-btn');
                if (resendBtn) {
                    if (this.resendClickHandler) {
                        resendBtn.removeEventListener('click', this.resendClickHandler);
                    }
                    this.resendClickHandler = () => {
                        AriFormUtils.loadingFullScreen();
                        this.resendEvent = true;
                        this.clearInputOTP();
                        this.checkOtpComplete();
                        this.callApiCheckInfo(endpoint, request, body, form, ariHeader, ariLang);
                    };
                    resendBtn.addEventListener('click', this.resendClickHandler);
                }
            }
        };
        const handleErrorCheckInfo = (error) => {
            var _a;
            AriFormUtils.removeLoadingFullScreen();
            AriFormUtils.showPopup('error', 'Failed', ((_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a.responseDesc) || (error === null || error === void 0 ? void 0 : error.responseDesc));
        };
        AriFormUtils.handleCAllAPI(`${AriForm_1.AriForm.baseUrl}/${AriForm_1.AriForm.serviceId}/${AriForm_1.AriForm.endpointGetOtp}/${form.formState.formId}`, 'POST', body, {}, handleSuccessCheckInfo, handleErrorCheckInfo);
    }
    renderOtpCode() {
        return `<div class="modal fade show" id="otp-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered ari-w-[90%] ari-max-w-[90%] sm:ari-max-w-[400px] ari-m-auto">
      <div class="modal-content">
      <div class="modal-header-custom">
           <div class="logo-verify-code"></div>
        <div class="ari-text-center otp-info-title ari-my-4 ari-w-full">
        <h1 class="m-auto ari-mt-4 ari-font-semibold ari-text-lg ari-text-gray-900 ari-text-center ">${AriFormUtils.getLangText("OTP Verification")}</h1>
          <p class=" m-auto ari-mt-1 ari-text-sm ari-text-gray-600 ari-max-w-xs ari-text-center">
         ${AriFormUtils.getLangText("We've sent verification code to")} ${this.otpInfo.authenType === 'SMSOTP' ? AriFormUtils.getLangText("phone number") : AriFormUtils.getLangText("email")}
          <span class="ari-font-semibold d-block ari-text-[18px]">${this.otpInfo.ctmPhoneNoOrEmail || ''}</span>
        </p>
        </div>
          <button type="button" class="close-modal-otp ari-text-[#01539f] ari-absolute ari-top-0 ari-right-0 ari-w-[25px] ari-h-[25px] ari-rounded-full ari-flex ari-justify-center ari-items-center ari-text-[25px]" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body ">
    <label class="ari-block ari-text-gray-700 ari-font-medium ari-mb-2" for="otp">
      ${AriFormUtils.getLangText("Verification Code")}
    </label>
          <div class="ari-m-auto">
            <div class="ari-flex ari-justify-between ari-mb-6">
              <input aria-label="OTP digit 1"
                class=" ari-w-10 ari-h-10 sm:ari-w-10 sm:ari-h-10 ari-border ari-border-gray-300 ari-rounded-lg ari-text-center ari-text-lg ari-font-semibold ari-text-gray-900 ari-focus:ari-outline-none ari-focus:ari-ring-2 ari-focus:ari-ring-blue-400"
                inputmode="numeric" maxlength="1" pattern="[0-9]*" type="text"
                 id="otp1" />
              <input aria-label="OTP digit 2"
                class="ari-w-10 ari-h-10 sm:ari-w-10 sm:ari-h-10 ari-border ari-border-gray-300 ari-rounded-lg ari-text-center ari-text-lg ari-font-semibold ari-text-gray-900 ari-focus:ari-outline-none ari-focus:ari-ring-2 ari-focus:ari-ring-blue-400"
                inputmode="numeric" maxlength="1" pattern="[0-9]*" type="text"
                 id="otp2" />
              <input aria-label="OTP digit 3"
                class="ari-w-10 ari-h-10 sm:ari-w-10 sm:ari-h-10 ari-border ari-border-gray-300 ari-rounded-lg ari-text-center ari-text-lg ari-font-semibold ari-text-gray-900 ari-focus:ari-outline-none ari-focus:ari-ring-2 ari-focus:ari-ring-blue-400"
                inputmode="numeric" maxlength="1" pattern="[0-9]*" type="text"
                 id="otp3" />
              <input aria-label="OTP digit 4"
                class="ari-w-10 ari-h-10 sm:ari-w-10 sm:ari-h-10 ari-border ari-border-gray-300 ari-rounded-lg ari-text-center ari-text-lg ari-font-semibold ari-text-gray-900 ari-focus:ari-outline-none ari-focus:ari-ring-2 ari-focus:ari-ring-blue-400"
                inputmode="numeric" maxlength="1" pattern="[0-9]*" type="text"
                 id="otp4" />
              <input aria-label="OTP digit 5"
                class="ari-w-10 ari-h-10 sm:ari-w-10 sm:ari-h-10 ari-border ari-border-gray-300 ari-rounded-lg ari-text-center ari-text-lg ari-font-semibold ari-text-gray-900 ari-focus:ari-outline-none ari-focus:ari-ring-2 ari-focus:ari-ring-blue-400"
                inputmode="numeric" maxlength="1" pattern="[0-9]*" type="text"
                 id="otp5" />
              <input aria-label="OTP digit 6"
                class="ari-w-10 ari-h-10 sm:ari-w-10 sm:ari-h-10 ari-border ari-border-gray-300 ari-rounded-lg ari-text-center ari-text-lg ari-font-semibold ari-text-gray-900 ari-focus:ari-outline-none ari-focus:ari-ring-2 ari-focus:ari-ring-blue-400"
                inputmode="numeric" maxlength="1" pattern="[0-9]*" type="text" id="otp6"/>
            </div>
            <div class="ari-flex ari-justify-center ari-gap-2 ari-items-center ari-mt-2">
              <button disabled type="button" class="btn btn btn-primary btn-md btn-block custom-ib-btn loader-size ari-w-full bpm-do-task-pdf">${AriFormUtils.getLangText("Submit")}</button>
            </div>
            <div class="coundown-wraper ari-text-gray-500 ari-font-medium ari-text-center ari-m-auto ari-mt-2"> </div>
            <div class=" wraper-resend-otp-btn d-none ari-gap-2 ari-items-center  ari-text-sm ari-text-gray-500 ari-font-medium ari-text-center ari-justify-center ari-mt-4">
               <p class="mt-4 text-center text-gray-700 text-sm">${AriFormUtils.getLangText("Didn't receive the code?")}</p>
              <button type="button" class="ari-text-blue-600 ari-mx-auto ari-mt-2 ari-text-center ari-text-sm ari-font-medium  ari-block resend-otp-btn">
              ${AriFormUtils.getLangText("Resend OTP Code")}
            </button>
            </div>
            
          </div>
  
        </div>
      </div>
    </div>
  </div>`;
    }
    // hungnq
    checkOtpComplete() {
        const otp = this.getFullOtpValue();
        const button = document.querySelector(".ari-w-full.bpm-do-task-pdf");
        if (button) {
            button.disabled = otp.length !== 6;
        }
    }
    getFullOtpValue() {
        let otp = '';
        for (let i = 1; i <= 6; i++) {
            const input = document.getElementById(`otp${i}`);
            if (input) {
                otp += input.value;
            }
        }
        return otp;
    }
    handleInput(current, nextFieldID) {
        current.value = current.value.replace(/[^0-9]/g, "");
        if (current.value.length === 1 && nextFieldID) {
            const nextField = document.getElementById(nextFieldID);
            if (nextField) {
                nextField.focus();
            }
        }
        this.checkOtpComplete();
    }
    handleBackspace(event, current, prevFieldID) {
        if (event.key === "Backspace" && current.value === "") {
            if (prevFieldID) {
                const prevField = document.getElementById(prevFieldID);
                if (prevField) {
                    prevField.focus();
                    prevField.value = "";
                    event.preventDefault();
                }
            }
        }
        this.checkOtpComplete();
    }
    initOtpInputs() {
        this.otpInputs.forEach((id, index) => {
            const input = document.getElementById(id);
            // Nếu đã có listener cũ thì gỡ ra
            if (this.listeners[id]) {
                input.removeEventListener("input", this.listeners[id].input);
                input.removeEventListener("keydown", this.listeners[id].keydown);
                input.removeEventListener("paste", this.listeners[id].paste);
            }
            // Tạo các hàm lắng nghe mới
            const inputHandler = () => {
                this.handleInput(input, this.otpInputs[index + 1]);
            };
            const keydownHandler = (event) => {
                this.handleBackspace(event, input, this.otpInputs[index - 1]);
            };
            const pasteHandler = (event) => {
                event.preventDefault();
                const pastedData = event.clipboardData.getData("text").replace(/\D/g, ""); // Chỉ lấy số
                // Dán từ vị trí đầu tiên
                for (let i = 0; i < this.otpInputs.length; i++) {
                    const char = pastedData[i] || "";
                    const targetInput = document.getElementById(this.otpInputs[i]);
                    if (targetInput) {
                        targetInput.value = char;
                    }
                }
                // Focus vào ô tiếp theo hợp lý
                const nextIndex = Math.min(pastedData.length, this.otpInputs.length - 1);
                const nextInput = document.getElementById(this.otpInputs[nextIndex]);
                nextInput === null || nextInput === void 0 ? void 0 : nextInput.focus();
                this.checkOtpComplete();
            };
            // Gán vào DOM
            input.addEventListener("input", inputHandler);
            input.addEventListener("keydown", keydownHandler);
            input.addEventListener("paste", pasteHandler); // ✨ Gắn cho tất cả input
            // Lưu để lần sau có thể gỡ ra
            this.listeners[id] = {
                input: inputHandler,
                keydown: keydownHandler,
                paste: pasteHandler
            };
        });
    }
    updateCountdownDisplay(seconds) {
        const min = Math.floor(seconds / 60);
        const sec = seconds % 60;
        this.countdownEl.textContent =
            `${min < 10 ? '0' + min : min}:${sec < 10 ? '0' + sec : sec}`;
    }
    startCountdown() {
        this.updateCountdownDisplay(this.countdownTime); // lần đầu hiển thị
        this.interval = setInterval(() => {
            this.countdownTime--;
            if (this.countdownTime <= 0) {
                clearInterval(this.interval);
                this.countdownEl.classList.add('hidden');
                document.querySelector('.wraper-resend-otp-btn').classList.remove('d-none');
            }
            else {
                this.updateCountdownDisplay(this.countdownTime);
            }
        }, 1000);
    }
    clearInputOTP() {
        for (let i = 0; i < this.otpInputs.length; i++) {
            const targetInput = document.getElementById(this.otpInputs[i]);
            if (targetInput) {
                targetInput.value = "";
            }
        }
    }
    // end hungnq
    renderBiometric(endpoint, request, body, form, ariHeader, ariLang) {
        // Tạo thẻ div
        const div = document.createElement('div');
        div.className = 'biometric-container ari-fixed ari-top-0 ari-left-0 ari-right-0 ari-bottom-0 ari-bg-white ari-z-[10000] ari-flex ari-justify-center';
        div.innerHTML = ` <div class="iframe-container ari-flex ari-justify-center ari-w-[90%]">
            <div id="loading" class="loading">Loading...</div>
            <iframe
                class=" ari-w-full"
                id="livenessIframe"
                title="Liveness Detection"
                src="${AriForm_1.AriForm.biometricLink}"
                allow="camera *; microphone *; autoplay *; clipboard-read; clipboard-write; geolocation; fullscreen *"
                style="visibility: hidden;"
            ></iframe>
        </div>`;
        document.body.appendChild(div);
        let iframeElement = null;
        let loadingElement = null;
        // Initialize when DOM is loaded
        iframeElement = document.getElementById('livenessIframe');
        loadingElement = document.getElementById('loading');
        const handleResult = (dataResult) => {
            var _a;
            if (dataResult && dataResult.message === "Success") {
                AriFormUtils.loadingFullScreen();
                this.callAPIDoTask(endpoint, request, body, form, ariHeader, ariLang, dataResult);
                window.removeEventListener('message', handleMessage);
                window.removeEventListener('error', handleError);
                window.removeEventListener('load', handleIframeLoad);
                div.remove();
            }
            else if (dataResult && dataResult.message !== "Success") {
                if ((_a = dataResult === null || dataResult === void 0 ? void 0 : dataResult.data) === null || _a === void 0 ? void 0 : _a.message) {
                    AriFormUtils.showPopup('error', 'Failed', dataResult.data.message);
                }
                this.enableComponents(form);
                window.removeEventListener('message', handleMessage);
                window.removeEventListener('error', handleError);
                window.removeEventListener('load', handleIframeLoad);
                div.remove();
            }
        };
        const handleMessage = (event) => {
            if (event.data === "getToken") {
                const parameters = {
                    username: AriForm_1.AriForm.biometricName,
                    password: AriForm_1.AriForm.biometricSecure,
                    retryTime: 3,
                    bioType: "face,nod,shake",
                    type: "getTokenResult",
                    language: AriFormUtils.getVariable("BlazorCulture") || "en_US"
                };
                // Delay sending parameters slightly
                setTimeout(() => {
                    if (iframeElement && iframeElement.contentWindow) {
                        iframeElement.contentWindow.postMessage(parameters, "*");
                    }
                }, 500); // 500ms delay
            }
            if (event.data.type === "bioResult") {
                handleResult(event.data);
            }
        };
        window.addEventListener('message', handleMessage);
        const handleIframeLoad = () => {
            // Hide loading indicator and show iframe
            if (loadingElement) {
                loadingElement.style.display = 'none';
            }
            if (iframeElement) {
                iframeElement.style.visibility = 'visible';
            }
        };
        iframeElement.addEventListener('load', handleIframeLoad);
        // Error handling
        const handleError = (event) => {
            console.error('Global error:', event.error);
        };
        window.addEventListener('error', handleError);
        // Handle iframe errors
        document.getElementById('livenessIframe').addEventListener('error', function () {
            if (loadingElement) {
                loadingElement.textContent = 'Failed to load. Please refresh the page.';
            }
        });
    }
    renderSelect(methods) {
        const info = super.elementInfo();
        info.type = 'select';
        info.attr.class = 'w-full d-inline-block form-control';
        info.changeEvent = 'change';
        //HungNQ  Bypass error pagination-select by edit form bootstrap
        info.ref = `${this.component.key}-select-authen-type`;
        //End HungNQ
        var select = `<div class="w-full choose-method-authen">
      <label class="col-form-label">Authen Type</label>
    
      ${this.renderTemplate('select', {
            input: info,
            selectOptions: methods.reduce((html, option) => html + this.renderTemplate('selectOption', {
                option,
                selected: option.selected,
                attrs: {}
            }), ''),
        })}</div>`;
        return select;
    }
    renderChoiceOptions(endpoint, request, body, form, ariHeader, ariLang, methods) {
        var _a, _b, _c;
        if (this.mdChooseOptions) {
            this.mdChooseOptions.hide();
            this.mdChooseOptions = null;
            (_a = document.querySelector('.wraper-modal-choose-authen-type')) === null || _a === void 0 ? void 0 : _a.remove();
        }
        const html = document.createElement("div");
        html.className = 'wraper-modal-choose-authen-type';
        html.innerHTML = `
    <div class="modal fade" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">${AriFormUtils.getLangText('Choose AuthenType')}</h5>
            <button type="button" class="btn-close-modal-authenType" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            ${this.renderSelect(methods)}
          </div>
          <div class="ari-mb-3 ari-flex ari-grap-2 ari-items-center ari-justify-center">
            <button type="button" class="btn btn-primary submit-select-authenType button-loading">
              ${AriFormUtils.getLangText('Submit')}
            </button>
          </div>
        </div>
      </div>
    </div>
  `;
        document.body.appendChild(html);
        const modalEl = html.querySelector(".modal");
        this.mdChooseOptions = new window.bootstrap.Modal(modalEl);
        this.mdChooseOptions.show();
        const select = html.querySelector('.choose-method-authen > select');
        select.removeAttribute('disabled');
        select.addEventListener('change', (event) => {
            this.authenType = event.target.value;
        });
        // --- FLAG để tránh vòng lặp ---
        this.isClosingModal = false;
        // --- Cleanup tất cả listeners ---
        this.cleanupModalEvents = () => {
            var _a, _b;
            (_a = html.querySelector('.submit-select-authenType')) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', this.submitModelChooseOptions);
            (_b = html.querySelector('.btn-close-modal-authenType')) === null || _b === void 0 ? void 0 : _b.removeEventListener('click', this.closeModelChooseOptions);
            modalEl.removeEventListener('hidden.bs.modal', this.handleModalHidden);
        };
        // --- Khi ấn Submit ---
        this.submitModelChooseOptions = () => {
            if (this.authenType === "BIOMETRIC") {
                this.renderBiometric(endpoint, request, body, form, ariHeader, ariLang);
            }
            else {
                AriFormUtils.loadingFullScreen();
                this.authenType = "SMSOTP";
                this.callApiCheckInfo(endpoint, request, body, form, ariHeader, ariLang);
            }
            this.closeModelChooseOptions();
        };
        // --- Khi ấn nút X hoặc click ngoài ---
        this.closeModelChooseOptions = () => {
            if (this.isClosingModal)
                return;
            this.isClosingModal = true;
            this.mdChooseOptions.hide();
        };
        // --- Khi modal thật sự đóng ---
        this.handleModalHidden = () => {
            this.isClosingModal = false;
            this.cleanupModalEvents();
            this.enableComponents(form);
            html.remove(); // xoá khỏi DOM để tránh rác
        };
        modalEl.addEventListener('hidden.bs.modal', this.handleModalHidden);
        (_b = html.querySelector('.btn-close-modal-authenType')) === null || _b === void 0 ? void 0 : _b.addEventListener('click', this.closeModelChooseOptions);
        (_c = html.querySelector('.submit-select-authenType')) === null || _c === void 0 ? void 0 : _c.addEventListener('click', this.submitModelChooseOptions);
    }
    getAdditionalParams(textContent) {
        const form = this.getRoot();
        const flattened = {};
        const components = {};
        AriFormUtils.eachComponent(form.components, (componentWrapper, path) => {
            const component = componentWrapper.component || componentWrapper;
            flattened[path] = component;
            components[component.key] = component;
        }, true);
        return this.evaluate(textContent, {
            form,
            flattened,
            components
        }, 'value');
    }
    bpmCommit(endpoint, body = {}) {
        var _a, _b, _c;
        const form = this.getRoot();
        const additionalParams = this.component.additionalParams ? this.getAdditionalParams(this.component.additionalParams) : {};
        var request = {};
        Object.assign(request, this.buildBodyBpmSubmit(form, this));
        body.dataset = request.dataset;
        body.ariFilePaths = request.ariFilePaths;
        body.payload = Object.assign({}, ((_a = body.payload) !== null && _a !== void 0 ? _a : {}));
        Object.keys(additionalParams).forEach(key => {
            const currentValue = body[key];
            const newValue = additionalParams[key];
            const isPlainObject = (val) => typeof val === "object" &&
                val !== null &&
                !Array.isArray(val);
            if (key in body) {
                if (isPlainObject(currentValue) && isPlainObject(newValue)) {
                    body[key] = Object.assign(Object.assign({}, currentValue), newValue);
                }
                else if (Array.isArray(currentValue) && Array.isArray(newValue)) {
                    body[key] = [...currentValue, ...newValue];
                }
                else {
                    body[key] = newValue;
                }
            }
            else {
                body[key] = newValue;
            }
        });
        console.log('Final BPM Commit Body:', body);
        const ariHeader = AriFormUtils.getVariable('clientInfo') ? AriFormUtils.getVariable('clientInfo') : AriFormUtils.getClientInfo();
        const ariLang = AriFormUtils.getVariable('BlazorCulture') || 'en-US';
        if (this.component.needOtp) {
            const authenTypeFormInfo = ((_b = form.formState.formInfo) === null || _b === void 0 ? void 0 : _b.authenType) || '';
            const authenTypeCustInfo = ((_c = form.formState.custInfo) === null || _c === void 0 ? void 0 : _c.authenType) || '';
            this.authenType = authenTypeFormInfo || authenTypeCustInfo || 'SMSOTP';
            if (this.authenType === "BIOMETRIC") {
                this.renderBiometric(endpoint, request, body, form, ariHeader, ariLang);
            }
            else if (this.authenType === "OPTIONS") {
                this.renderChoiceOptions(endpoint, request, body, form, ariHeader, ariLang, form.formState.custInfo.methods);
            }
            else {
                this.callApiCheckInfo(endpoint, request, body, form, ariHeader, ariLang);
            }
        }
        else {
            this.callAPIDoTask(endpoint, request, body, form, ariHeader, ariLang);
        }
    }
    //end Fiona
    onClick(event) {
        var _a;
        this.triggerCaptcha();
        // Don't click if disabled or in builder mode.
        if (this.disabled || this.options.attachMode === 'builder') {
            return;
        }
        this.dataValue = true;
        if (this.component.action !== 'submit' && this.component.showValidations) {
            this.emit('checkValidity', this.data);
        }
        switch (this.component.action) {
            //Fiona - add bpm action
            case 'bpmsubmit': {
                const form = this.getRoot();
                AriFormUtils.removeLoadingFullScreen();
                this.bpmCommit(`${AriForm_1.AriForm.endpointBpmInit}${form.formState.formId}`);
                break;
            }
            case 'bpmapprove': {
                AriFormUtils.comfirmwithInput('Confirm task approval', 'Are you sure you want to approve this task?', 'Approve', 'swalApprove').then(rs => {
                    if (rs) {
                        const form = this.getRoot();
                        this.bpmCommit(AriForm_1.AriForm.endpointBpmApprove, {
                            taskId: form.formState.taskId,
                            activityId: form.formState.activityId,
                            activityType: form.formState.activityType,
                            payload: {
                                action: 'Approve',
                                //reasonDesc: rs.reasonDesc
                            }
                        });
                    }
                });
                break;
            }
            case 'bpmreject': {
                const inputParamsReject = [{
                        id: 'reasonCode',
                        type: 'textbox',
                        placeholders: 'Select a reason for rejection.',
                        require: true,
                        source: []
                    },
                    {
                        id: 'reasonDesc',
                        type: 'textbox',
                        require: true,
                        placeholders: 'Enter a description for the rejection reason.'
                    }];
                AriFormUtils.comfirmwithInput('Confirm rejection of the request.', 'Are you sure you want to reject this request? Once rejected, the task will be canceled.', 'Reject', 'swalReject', inputParamsReject).then(rs => {
                    if (rs) {
                        const form = this.getRoot();
                        this.bpmCommit(AriForm_1.AriForm.endpointBpmApprove, {
                            taskId: form.formState.taskId,
                            activityId: form.formState.activityId,
                            activityType: form.formState.activityType,
                            payload: {
                                action: 'Reject',
                                reasonCode: rs.reasonCode,
                                reasonDesc: rs.reasonDesc,
                            }
                        });
                    }
                });
                break;
            }
            case 'bpmsendback': {
                const inputParamSendBack = [{
                        id: 'reasonCode',
                        type: 'textbox',
                        require: true,
                        placeholders: 'Select a reason for sending back',
                        source: []
                    },
                    {
                        id: 'reasonDesc',
                        type: 'textbox',
                        require: true,
                        placeholders: 'Enter a description for the sending back reason'
                    }];
                AriFormUtils.comfirmwithInput('Confirm the request to send back the task', 'Enter the reason for sending back', 'Send Back', 'swalSendback', inputParamSendBack).then(rs => {
                    if (rs) {
                        const form = this.getRoot();
                        this.bpmCommit(AriForm_1.AriForm.endpointBpmApprove, {
                            taskId: form.formState.taskId,
                            activityId: form.formState.activityId,
                            activityType: form.formState.activityType,
                            payload: {
                                action: 'SendBack',
                                reasonCode: rs.reasonCode,
                                reasonDesc: rs.reasonDesc
                            }
                        });
                    }
                });
                break;
            }
            case 'bpmtask': {
                const form = this.getRoot();
                this.bpmCommit(AriForm_1.AriForm.endpointBpmDoTask, {
                    taskId: form.formState.taskId,
                    activityId: form.formState.activityId,
                    activityType: form.formState.activityType
                });
                break;
            }
            //end Fiona
            case 'saveState':
            case 'submit':
                event.preventDefault();
                event.stopPropagation();
                this.loading = true;
                this.emit('submitButton', {
                    noValidate: this.component.state === 'draft',
                    state: this.component.state || 'submitted',
                    component: this.component,
                    instance: this
                });
                break;
            case 'event':
                this.emit(this.interpolate(this.component.event), this.data);
                this.events.emit(this.interpolate(this.component.event), this.data);
                this.emit('customEvent', {
                    type: this.interpolate(this.component.event),
                    component: this.component,
                    data: this.data,
                    event: event
                });
                break;
            case 'custom': {
                // Get the AriFormForm at the root of this component's tree
                const form = this.getRoot();
                const flattened = {};
                const components = {};
                (0, utils_1.eachComponent)(form.components, (componentWrapper, path) => {
                    const component = componentWrapper.component || componentWrapper;
                    flattened[path] = component;
                    components[component.key] = component;
                }, true);
                this.evaluate(this.component.custom, {
                    form,
                    flattened,
                    components
                });
                this.triggerChange();
                break;
            }
            case 'runjs': {
                // Get the AriFormForm at the root of this component's tree
                const form = this.getRoot();
                const flattened = {};
                const components = {};
                (0, utils_1.eachComponent)(form.components, (componentWrapper, path) => {
                    const component = componentWrapper.component || componentWrapper;
                    flattened[path] = component;
                    components[component.key] = component;
                }, true);
                var fun = window['TestRunJS'];
                //console.log(form);
                this.evaluate(fun, {
                    form,
                    flattened,
                    components
                });
                this.triggerChange();
                break;
            }
            case 'url':
                this.loading = true;
                this.emit('requestButton', {
                    component: this.component,
                    instance: this
                });
                this.emit('requestUrl', {
                    url: this.interpolate(this.component.url),
                    headers: this.component.headers
                });
                break;
            //simple
            case 'aripost':
                var args = this.evalContext(args);
                this.loading = true;
                this.emit('requestButton', {
                    component: this.component,
                    instance: this
                });
                this.emit('requestAri', {
                    com: this.component,
                    url: this.interpolate(this.component.ariaction),
                    aribody: this.component.aribody,
                    resultType: this.component.resultType,
                    args: args
                });
                break;
            case 'swpage':
                //Fiona
                var actions = AriFormUtils.getVariableTemp('actions') ? JSON.parse(AriFormUtils.getVariableTemp('actions')) : [];
                var url = this.component.autodoaction ? actions ? (_a = actions.find((value) => value.actionType === this.component.actionType)) === null || _a === void 0 ? void 0 : _a.pageId : '' : this.interpolate(this.component.urltarget);
                //end Fiona
                args = this.evalContext(args);
                this.emit('redirectPage', {
                    url: url,
                    paramGet: this.component.swpageParamGet,
                    paramPost: this.component.swpageParamPost,
                    openNewTab: this.component.openNewTab,
                    form: args,
                    redirectToStaticPage: this.component.redirectToStaticForm
                });
                break;
            case 'reset':
                this.emit('resetForm');
                break;
            case 'back': //HungNQ
                window.history.back();
                break;
            case 'delete':
                this.emit('deleteSubmission');
                break;
            case 'oauth':
                if (this.root === this) {
                    console.warn('You must add the OAuth button to a form for it to function properly');
                    return;
                }
                // Display Alert if OAuth config is missing
                if (!this.oauthConfig) {
                    this.root.setAlert('danger', 'OAuth not configured. You must configure oauth for your project before it will work.');
                    break;
                }
                // Display Alert if oAuth has an error is missing
                if (this.oauthConfig.error) {
                    this.root.setAlert('danger', `The Following Error Has Occured ${this.oauthConfig.error}`);
                    break;
                }
                this.openOauth(this.oauthConfig);
                break;
        }
    }
    openOauth(settings) {
        if (!this.root.ariform) {
            console.warn('You must attach a Form API url to your form in order to use OAuth buttons.');
            return;
        }
        /*eslint-disable camelcase */
        let params = {
            response_type: 'code',
            client_id: settings.clientId,
            redirect_uri: (settings.redirectURI && this.interpolate(settings.redirectURI)) || window.location.origin || `${window.location.protocol}//${window.location.host}`,
            scope: settings.scope
        };
        if (settings.state) {
            params.state = settings.state;
        }
        else if (settings.code_challenge) {
            params.code_challenge = settings.code_challenge;
            params.code_challenge_method = 'S256';
        }
        /*eslint-enable camelcase */
        // Needs for the correct redirection URI for the OpenID
        const originalRedirectUri = params.redirect_uri;
        // Make display optional.
        if (settings.display) {
            params.display = settings.display;
        }
        params = Object.keys(params).map(key => {
            return `${key}=${encodeURIComponent(params[key])}`;
        }).join('&');
        const separator = settings.authURI.indexOf('?') !== -1 ? '&' : '?';
        const url = `${settings.authURI}${separator}${params}`;
        const popup = window.open(url, settings.provider, 'width=1020,height=618');
        const interval = setInterval(() => {
            try {
                const popupHost = popup.location.host;
                const currentHost = window.location.host;
                if (popup && !popup.closed && popupHost === currentHost) {
                    popup.close();
                    const params = popup.location.search.substr(1).split('&').reduce((params, param) => {
                        const split = param.split('=');
                        params[split[0]] = split[1];
                        return params;
                    }, {});
                    if (params.error) {
                        alert(params.error_description || params.error);
                        this.root.setAlert('danger', params.error_description || params.error);
                        return;
                    }
                    // TODO: check for error response here
                    if (settings.state !== params.state) {
                        this.root.setAlert('danger', 'OAuth state does not match. Please try logging in again.');
                        return;
                    }
                    // Depending on where the settings came from, submit to either the submission endpoint (old) or oauth endpoint (new).
                    let requestPromise = Promise.resolve();
                    if (lodash_1.default.has(this, 'root.form.config.oauth') && this.root.form.config.oauth[this.component.oauthProvider]) {
                        params.provider = settings.provider;
                        params.redirectURI = originalRedirectUri;
                        // Needs for the exclude oAuth Actions that not related to this button
                        params.triggeredBy = this.oauthComponentPath;
                        requestPromise = this.root.ariform.makeRequest('oauth', `${this.root.ariform.projectUrl}/oauth2`, 'POST', params);
                    }
                    else {
                        const submission = { data: {}, oauth: {} };
                        submission.oauth[settings.provider] = params;
                        submission.oauth[settings.provider].redirectURI = originalRedirectUri;
                        if (settings.logoutURI) {
                            this.root.ariform.oauthLogoutURI(settings.logoutURI);
                        }
                        // Needs for the exclude oAuth Actions that not related to this button
                        submission.oauth[settings.provider].triggeredBy = this.oauthComponentPath;
                        requestPromise = this.root.ariform.saveSubmission(submission);
                    }
                    requestPromise.then((result) => {
                        this.root.onSubmit(result, true);
                    })
                        .catch((err) => {
                        this.root.onSubmissionError(err);
                    });
                }
            }
            catch (error) {
                if (error.name !== 'SecurityError' && (error.name !== 'Error' || error.message !== 'Permission denied')) {
                    this.root.setAlert('danger', error.message || error);
                }
            }
            if (!popup || popup.closed || popup.closed === undefined) {
                clearInterval(interval);
            }
        }, 100);
    }
    get oauthComponentPath() {
        const pathArray = (0, utils_1.getArrayFromComponentPath)(this.path);
        return lodash_1.default.chain(pathArray).filter(pathPart => !lodash_1.default.isNumber(pathPart)).join('.').value();
    }
    focus() {
        if (this.refs.button) {
            this.refs.button.focus();
        }
    }
    triggerCaptcha() {
        if (!this.root) {
            return;
        }
        let captchaComponent;
        this.root.everyComponent((component) => {
            if (/^(re)?captcha$/.test(component.component.type) &&
                component.component.eventType === 'buttonClick' &&
                component.component.buttonKey === this.component.key) {
                captchaComponent = component;
            }
        });
        if (captchaComponent) {
            captchaComponent.verify(`${this.component.key}Click`);
        }
    }
}
exports.default = ButtonComponent;
